module.exports = __webpack_public_path__ + "img/menu-icon-4-5.f8fbf7fe.svg";